(function() {
  'use strict';

  function initSizeGuideDrawer() {
    if (!document.getElementById('SizeGuideDrawer')) return;
    theme.SizeGuideDrawer = new theme.Drawers('SizeGuideDrawer', 'size-guide');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideDrawer);
  } else {
    initSizeGuideDrawer();
  }
})();
